import React from 'react';

interface typeProps {
  name: string;
  label: string;
  placeholder: string;
  data: any;
  setData: Function;
  required?: boolean;
}

const Textarea = ({
  name,
  label,
  placeholder,
  data,
  setData,
  required
}: typeProps) => {



  return (
    <div className="field">
      <label htmlFor="label">{label}:</label>
      <textarea
        id={name}
        value={data}
        name={name}
        onChange={(event: any) => {
          setData(event);
        }}
        placeholder={placeholder}
        required={required}
      >
      </textarea>
    </div>
  );
};

export default Textarea;
